import { render, staticRenderFns } from "./FreeCollectingForm.vue?vue&type=template&id=d5ed6640"
import script from "./FreeCollectingForm.vue?vue&type=script&lang=js"
export * from "./FreeCollectingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports